import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { Notice, NoticeCreateEdit, NoticesType } from "../../types/slices/noticesType";

const initialState: NoticesType = {
  status: ApiStatus.FETCHED,
  notices: [],
  errorMessage: undefined,
  editNotice: {} as NoticeCreateEdit,
  selectedNotice: {} as Notice,
  isEdit: false,
  openModal: false,
};

const noticeSlice = createSlice({
  name: "notice",
  initialState,
  reducers: {
    onFetchNotices(state, { payload }: { payload: Notice[] }) {
      state.status = ApiStatus.FETCHED;
      state.notices = payload;
      state.errorMessage = undefined;
    },
    changeStatusNotices(state, { payload }: { payload: ApiStatus }) {
      state.status = payload;
    },
    onSetEditNotice(state, { payload }: { payload: NoticeCreateEdit }) {
      state.editNotice = payload;
    },
    onSetSelectedNotice(state, { payload }: { payload: Notice }) {
      state.selectedNotice = payload;
    },
    onSetOpenModal(state, { payload }: { payload: boolean }) {
      state.openModal = payload;
    },
    onChangeIsEdit(state, { payload }: { payload: boolean }) {
      state.isEdit = payload;
    },
  },
});

export const selectNoticeState = (state: any) => state.noticeSlice;
export default noticeSlice.reducer;

export const {
  onFetchNotices,
  changeStatusNotices,
  onSetEditNotice,
  onSetSelectedNotice,
  onSetOpenModal,
  onChangeIsEdit,
} = noticeSlice.actions;